<template>
  <div>
    <b-row align-h="center" class="mb-2">
      <div id="pa-dimensions">
        <div class="diagram-container">
          <img :src="dimensionsImg" alt="dimensions-img" class="d-none d-md-block">
          <img :src="dimensionsImgLabeled" alt="dimensions-img-labeled" class="d-block d-md-none">

          <div class="input entry-device-1">
            <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">entrada</p>
              </div>
              <b-select
                v-model="detailsForm.entry_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input entry-sensor">
            <ValidationProvider rules="required" name="Sensor" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Sensor</p>
              <b-select
                v-model="detailsForm.entry_sensor"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="emergencyDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input alerts">
            <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Alertas</p>
              <b-select
                v-model="detailsForm.alerts"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="alertsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-1">
            <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">emergencia</p>
              </div>
              <b-select
                v-model="detailsForm.exit_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="emergencyDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-2">
            <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">salida</p>
              </div>
              <b-select
                v-model="detailsForm.exit_device_2"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="exitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </b-row>

    <!-- dimensions sm inputs -->
    <div class="d-block d-md-none">

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de entrada" :blank="detailsForm.entry_device_1" show-reset @reset="detailsForm.entry_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Sensor" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Sensor" :blank="detailsForm.entry_sensor" show-reset @reset="detailsForm.entry_sensor = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_sensor"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="emergencyDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Alertas" :blank="detailsForm.alerts" show-reset @reset="detailsForm.alerts = null" />
            </template>
            <b-select
              v-model="detailsForm.alerts"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="alertsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de salida 1" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de emergencia" :blank="detailsForm.exit_device_1" show-reset @reset="detailsForm.exit_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="emergencyDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-4">
        <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida" :blank="detailsForm.exit_device_2" show-reset @reset="detailsForm.exit_device_2 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_2"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="exitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'

import {
  entryExitDevicesOptions,
  communicationDevicesOptions,
  sensorsOptions,
  alertsOptions,
  emergencyDevicesOptions
} from '../../../../../sharedOptions/controlesAccesoModule'

export default {
  name: 'PuertaAutomatica',
  components: {
    Label,
    Button,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionsImg: require('../../../../../../assets/images/control_acceso/puerta_automatica.png'),
      dimensionsImgLabeled: require('../../../../../../assets/images/control_acceso/puerta_automatica_labeled.png'),
      entryExitDevicesOptions: entryExitDevicesOptions,
      emergencyDevicesOptions: emergencyDevicesOptions
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital,
    }),
    communicationDevicesOptions () {
      return communicationDevicesOptions.filter(option => option.value !== 'Botón de salida')
    },
    sensorsOptions() {
      return sensorsOptions.filter(option => option.value !== 'Evoloop')
    },
    alertsOptions() {
      return alertsOptions.filter(option => option.value !== 'Intermitente')
    },
    exitDevicesOptions () {
      return [
        { value: null, text: '---Seleccionar---' },
        { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
        { value: 'Lector QR', text: 'Lector QR' },
        { value: 'Teclado numérico', text: 'Teclado numérico' },
        { value: 'Lector biométrico', text: 'Lector biométrico' },
        { value: 'intercomunicador', text: 'intercomunicador' },
        { value: 'Botón de salida', text: 'Botón de salida' },
        { value: 'Sensor de movimiento REX', text: 'Sensor de movimiento REX' },
        { value: 'N/A', text: 'N/A' }
      ]
    }
  }
}
</script>


<style scoped lang="scss">
  #pa-dimensions {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 59.5rem;

      img {
        width: 100%;
        height: auto;
        align-self: center;
      }
    }

    .input {
      position: absolute;
      z-index: 10;
      min-width: 180px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: rgba(255, 255, 255, 0.94);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .label {
        display: none;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 0;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }
    }
    // inputs
    .entry-device-1 {
      top: 53%;
      left: -3%;
    }
    .entry-sensor {
      top: 17%;
      left: 10%;
    }
    .alerts {
      top: 26%;
      right: 2%;
    }
    .exit-device-1 {
      bottom: 57%;
      right: -9%;
    }
    .exit-device-2 {
      bottom: 41%;
      right: 0%;
    }
  }

  @media (max-width: 768px) {
    #pa-dimensions {
      .input {
        min-width: 0;
        width: auto;
        padding: 0px;
        border: none;
        background: transparent;
        box-shadow: none;

        select {
          display: none
        }

        .label {
          font-size: 7px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          letter-spacing: normal;
          margin: 0;
        }

        &:hover {
          border: none;
          transform: none;
        }
      }
      // inputs
      .entry-device-1 {
        top: 52%;
        left: -3%;
      }
      .entry-sensor {
        top: 18%;
        left: 22%;
      }
      .alerts {
        top: 27%;
        right: 11%
      }
      .exit-device-1 {
        bottom: 57%;
        right: 5%;
      }
      .exit-device-2 {
        bottom: 41%;
        right: 7%;
      }
    }
  }
</style>
